jQuery(function(){
  if ($('#gsod-world-map').length > 0) {
    const baseUrl = $('#base-url').data('base-url');

    let mapData;
    let mapType = 'MT-AA';
    let selectedRegions;
    let colors = {
      'Improved': '#48CE96',
      'Remained': '#7D8A98',
      'Deteriorated': '#F56363',
      'Authoritarian': '#EAA146',
      'Democracy': '#97DDCC',
      'Hybrid': '#A18CBF',
      'Value': '#2260DA',
    };

    // API settings
    const settings = {
      // "url": baseUrl + "api/idea_country/gsodworldmapresource",
      "url": "https://idea.int/democracytracker/api/idea_country/gsodworldmapresource",
      // "url": "https://cors-anywhere.herokuapp.com/https://idea.int/democracytracker/api/idea_country/gsodworldmapresource",
      // "url": "https://api.pedle.co:8080/https://idea.int/democracytracker/api/idea_country/gsodworldmapresource",
      "method": "GET",
      "timeout": 0,
      "headers": {
        "Content-Type": "application/json",
        "x-requested-with": "XMLHttpRequest",
        // 'Access-Control-Allow-Origin': baseUrl,
        // 'Access-Control-Allow-Credentials': 'true',
      },
      error: function(error) {
        console.log('error', error);
      }
    };

    console.log('settings', settings);

    // Call API to get chart data
    $.ajax(settings).done(function (response) {
      mapData = response;
      console.log('worldmap response', response);
      // mapData = JSON.parse(response);
      console.log('mapData', mapData);

      // console.log('MT', mapData['monthly_trends']);

      monthlyTrends('all_attributes');
      switchMapLegend();

      $('#map-loading-blocker').fadeOut(1000, function(){
        $(this).remove();
      });
    });

    var theMap = $("#gsod-world-map");

    theMap.vectorMap({
      map: "world_mill",
      backgroundColor: "white",
      panOnDrag: true,
      zoomAnimate: true,
      zoomOnScroll: false,
      // zoomMax: 30,
      // zoomStep: 1.6,
      markerStyle: {
        initial: {
          // fill: 'transparent',
          stroke: "#222222",
          "stroke-width": 3,
          r: 6,
        },
      },
      focusOn: {
        x: 0.5,
        y: 0.5,
        scale: 1,
      },
      regionStyle: {
        initial: {
          fill: "#F0F0F0",
          "fill-opacity": 1,
          stroke: "none",
          "stroke-width": 0,
          "stroke-opacity": 1,
        },
      },
      onRegionClick: function (event, code) {

      },
      onRegionOver: function (e, code) {
        e.preventDefault();

        if (selectedRegions === undefined || selectedRegions.indexOf(code) < 0) {
          return;
        }

        $("body").append(getToolTip(code));

        var tip = $("body .map-tool-tip");

        $(this).on('mousemove', function (e) {
          var top = window.pageYOffset || document.documentElement.scrollTop;

          tip.css("top", e.pageY - 15 - top + "px");
          tip.css("left", e.pageX + "px");
        });
      },
      onRegionOut: function () {
        $("body .map-tool-tip").remove();
      },
      onRegionTipShow: function (e) {
        e.preventDefault();
        return false;
      },
      onViewportChange: function (e, scale) {
        // console.log('onViewportChange', e.target, 'scale', scale);
      },
    });

    var myMap = theMap.vectorMap("get", "mapObject");

    // return;

    // Western Sahara custom border ///////////////////////////////////////////////////////////////
    var borderPath = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "path"
    );

    borderPath.setAttributeNS(null, "d", "M392.75 211.70 l6.7 0");
    borderPath.setAttributeNS(null, "stroke", "white");
    borderPath.setAttributeNS(null, "stroke-width", "0.5");
    borderPath.setAttributeNS(null, "stroke-dasharray", "0.5, 0.5");

    theMap.find("svg").find("g").first().append(borderPath);

    // India Pakistan custom border
    borderPath = document.createElementNS("http://www.w3.org/2000/svg", "path");

    borderPath.setAttributeNS(
      null,
      "d",
      "M609 201 l2 -0.5, 0.5 -1, 1.5 -0.5, 1.5 0.75, 1.5 0, 1.5 1"
    );
    borderPath.setAttributeNS(null, "stroke", "white");
    borderPath.setAttributeNS(null, "stroke-width", "0.5");
    borderPath.setAttributeNS(null, "stroke-dasharray", "0.5, 0.5");
    borderPath.setAttributeNS(null, "fill", "transparent");

    theMap.find("svg").find("g").first().append(borderPath);

    borderPath = document.createElementNS("http://www.w3.org/2000/svg", "path");

    borderPath.setAttributeNS(
      null,
      "d",
      "M607 199.75 l-2.25 -1.75, -0.75 -1.75, 0 -2.25, 1.75 -0.75, -1.5 -2, -0.75 0, 0 -1, 2 -2"
    );
    borderPath.setAttributeNS(null, "stroke", "white");
    borderPath.setAttributeNS(null, "stroke-width", "0.5");
    borderPath.setAttributeNS(null, "stroke-dasharray", "0.5, 0.5");
    borderPath.setAttributeNS(null, "fill", "transparent");

    theMap.find("svg").find("g").first().append(borderPath);

    borderPath = document.createElementNS("http://www.w3.org/2000/svg", "path");

    borderPath.setAttributeNS(null, "stroke", "#d8d8d8");
    borderPath.setAttributeNS(
      null,
      "d",
      "M607.5 199.75 l-2.0 -4.3, 1.5 -1.3, 4 0.85, 2.5 -0.5, 2 -1.75"
    );
    borderPath.setAttributeNS(null, "stroke-width", "1.0");
    borderPath.setAttributeNS(null, "stroke-dasharray", "0.5, 0.5");
    borderPath.setAttributeNS(null, "fill", "transparent");

    theMap.find("svg").find("g").first().append(borderPath);

    myMap.clearSelectedRegions();

    // On map type changed
    $('input[name="map_type"]').on('change', function() {
      const val = $(this).val();

      mapType = val;

      switch (val) {
        case 'MT-AA': monthlyTrends('all_attributes'); break;
        case 'MT-RG': monthlyTrends('checks_on_government'); break;
        case 'MT-FR': monthlyTrends('fundamental_rights'); break;
        case 'MT-CG': monthlyTrends('impartial_administration'); break;
        case 'MT-IA': monthlyTrends('participatory_engagement'); break;
        case 'MT-PE': monthlyTrends('representative_government'); break;

        case 'AV-RG': annualValues('checks_on_government'); break;
        case 'AV-FR': annualValues('fundamental_rights'); break;
        case 'AV-CG': annualValues('impartial_administration'); break;
        case 'AV-IA': annualValues('participatory_engagement'); break;
        case 'AV-PE': annualValues('representative_government'); break;

        case 'ART': allRegime(); break;
      
        default:
          break;
      }

      switchMapLegend();
    });


    function monthlyTrends(type) {
      const data = mapData['monthly_trends'][type];

      // console.log('MT', mapData['monthly_trends']['all_attributes']);
      // console.log('MT', mapData['monthly_trends'][type]);

      myMap.clearSelectedRegions();

      data.map((item, key) => {
        if (myMap.regions[item.country] !== undefined) {
          myMap.regions[item.country].element.config.style.selected.fill = colors[item.value];
          myMap.setSelectedRegions(item.country);
        } // else {
          // console.log('!Region not found: ', item.country);
        //}
      });

      selectedRegions = myMap.getSelectedRegions();
    }

    function annualValues(type) {
      const data = mapData['annual_values'][type];
      
      myMap.clearSelectedRegions();

      data.map((item, key) => {
        const v = item.value;
        const opacity = Math.floor(((v * 0.8) + 0.2) * 255).toString(16);
        const color = colors['Value'] + opacity;
  
        if (myMap.regions[item.country] !== undefined) {
          myMap.regions[item.country].element.config.style.selected.fill = color;
          // myMap.regions[item.country].element.config.style.selected.fill = colors[item.value];
          myMap.setSelectedRegions(item.country);
        } else {
          console.log('!Region not found: ', item.country);
        }
      });

      selectedRegions = myMap.getSelectedRegions();
    }

    function allRegime() {
      const data = mapData['regime_type'];

      myMap.clearSelectedRegions();

      data.map((item, key) => {
        if (myMap.regions[item.country] !== undefined) {
          myMap.regions[item.country].element.config.style.selected.fill = colors[item.value];
          myMap.setSelectedRegions(item.country);
        } else {
          console.log('!Region not found: ', item.country);
        }
      });

      selectedRegions = myMap.getSelectedRegions();
    }

    // Return tooltip HTML
    function getToolTip(code) {
      const data = getDataForTooltip(mapType, code);

      return (
        '<div class="map-tool-tip drop-shadow-tooltip bg-white text-center px-1 py-3"><div class="country-name font-aileron text-sm font-bold border-b border-grey-dark px-2 pb-2">' +
        data.name +
        '</div><div class="font-aileron text-lg px-2 pt-2">' +
        data.value +
        "</div></div>"
      );
    }

    function getDataForTooltip(type, code) {
      let dataSet;

      switch (type) {
        case 'MT-AA': 
          dataSet = mapData['monthly_trends']['all_attributes'];
          break;
        case 'MT-RG': 
          dataSet = mapData['monthly_trends']['checks_on_government'];
          break;
        case 'MT-FR': 
          dataSet = mapData['monthly_trends']['fundamental_rights'];
          break;
        case 'MT-CG': 
          dataSet = mapData['monthly_trends']['impartial_administration'];
          break;
        case 'MT-IA': 
          dataSet = mapData['monthly_trends']['participatory_engagement'];
          break;
        case 'MT-PE': 
          dataSet = mapData['monthly_trends']['representative_government'];
          break;

        case 'AV-RG':
          dataSet = mapData['annual_values']['checks_on_government'];
          break;
        case 'AV-FR':
          dataSet = mapData['annual_values']['fundamental_rights'];
          break;
        case 'AV-CG':
          dataSet = mapData['annual_values']['impartial_administration'];
          break;
        case 'AV-IA':
          dataSet = mapData['annual_values']['participatory_engagement'];
          break;
        case 'AV-PE':
          dataSet = mapData['annual_values']['representative_government'];
          break;
      
        case 'ART':
          dataSet = mapData['regime_type'];
          break;

        default:
          break;
      }

      // console.log('dataSet', dataSet);

      const data = dataSet.find((item, key) => {
        if (item.country === code) {
          return item;
        }
      });

      // console.log('data', data);

      return data;
    }

    function switchMapLegend() {
      $('.map-legend').addClass('hidden');
      $('#map-legend-'+mapType.substring(0,2)).removeClass('hidden');
    }
  }
});
